export default __webpack_public_path__ + "78b83635c4b3b4eb1a08659bd59e8b8b.png";